import * as React from 'react';

import styles from './comment.css';

export interface IImageComment {
  comment: string;
}

const MAX_LENGTH_COMMENT = 50;

export const wrapLongComment = (comment: string) => {
  return comment.length > MAX_LENGTH_COMMENT ? `${comment.slice(0, MAX_LENGTH_COMMENT)}…` : comment;
};

export function Comment(props: IImageComment) {
  const { comment } = props;

  if (!comment) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['comment']}>{wrapLongComment(comment)}</div>
    </div>
  );
}
